<script setup>
import LegalDocument from "../components/LegalDocument.vue"
</script>
<template><LegalDocument kind="privacy" /></template>
